import type { Project } from "@overmap-ai/common"
import { memo, useMemo } from "react"

import { useAppSelector } from "../../store"
import { selectMapStyle, selectShowProjectBounds } from "../../store/selectors"
import { Layer, Source } from "../components"
import { MapSlotLayerId } from "../enums"
import { mapStyleColorMapping } from "../mappings"

interface ProjectBoundsLayerProps {
	project: Project
}

export const ProjectBoundsLayer = memo((props: ProjectBoundsLayerProps) => {
	const { project } = props

	const mapStyle = useAppSelector(selectMapStyle)
	const showProjectBounds = useAppSelector(selectShowProjectBounds)
	const color = mapStyleColorMapping[mapStyle]

	const paint = useMemo(() => {
		return { "line-color": color, "line-dasharray": [2, 4], "line-width": 1.5 }
	}, [color])

	return showProjectBounds ? (
		<Source id="project-bounds-source" key="project-bounds-source" type="geojson" data={project.bounds}>
			<Layer
				id="project-bounds-line-layer"
				key="project-bounds-line-layer"
				type="line"
				paint={paint}
				beforeId={MapSlotLayerId.PROJECT_BOUNDS}
			/>
		</Source>
	) : null
})
ProjectBoundsLayer.displayName = "ProjectBoundsLayer"
